export default __webpack_public_path__ + "static/media/preciosReg_leed_febENG_V.a96c1df5.png";